<template>
  <v-dialog
  persistent
  max-width="400px"
  v-model="showSplitInvoiceModal"
  >
    <v-card v-if="currentJob.id">
      <v-container class="modal-pad">
        <v-layout row align-center wrap>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Split the invoice</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn fab flat medium @click="closeModal()">
              <v-icon >close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <!-- screen 1 -->
        <transition name="fade" mode="out-in">
        <v-layout row wrap align-center justify-center v-if='screen === 1'>
          <v-flex xs12 >
            <span class="theme--light v-label caption">% of this job to bill</span>
          </v-flex>
          <v-flex xs3
          >
            <v-text-field
                  v-model="percentValue"
                  type="text"
                  suffix="%"
                  hide-details
                  class="splitpercent"
                  ></v-text-field>
          </v-flex >
          <v-flex xs12 mt-3 >
            <v-slider
              v-model="percentValue"
            ></v-slider>
          </v-flex >
          <v-flex xs12 text-xs-right>
          <v-btn style="margin-left:0; margin-right:0;" depressed  color="primary" :disabled="!enableSave" @click="screen = 2">Continue</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-center mt-4 v-else>
        <v-flex>
          <p class="caption">This will result in:</p>
            <p class="caption mb-0 text-xs-left">A new invoice of: <span class="bold body-1">{{newAmount | toCurrency(lang, currCode) }}</span></p>
            <!-- <div v-for="item in newLineItems"  :key="item.id + 'new'">
              <p class="body-smaller mb-0">{{item.description}}: {{item.amount | toCurrency(lang, currCode) }}</p>
            </div> -->
            <p class="caption mt-3 mb-0 text-xs-left">Remaining on original: <span class="bold body-1">{{remainderAmount | toCurrency(lang, currCode) }}</span></p>
            <!-- <div v-for="item in remainingLineItems"  :key="item.id + 'remain'">
              <p class="body-smaller mb-0">{{item.description}}: {{item.amount | toCurrency(lang, currCode) }}</p>
            </div> -->
        </v-flex>
        <v-flex xs6 mt-4>
          <v-btn style="margin-left:0; margin-right:0;" depressed  color="primary" :disabled="!enableSave" @click="screen = 1">Back</v-btn>
        </v-flex>
        <v-flex xs6 mt-4 text-xs-right>
          <v-btn style="margin-left:0; margin-right:0;" depressed  color="primary" :disabled="!enableSave" @click="onSaveChanges">Yes, go ahead</v-btn>
        </v-flex>
        </v-layout>
        </transition>
        <!-- end screen 1 -->
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'

export default {
  name: 'SplitInvoiceModal',
  data () {
    return {
      screen: 1,
      percentValue: 50,
      newAmount: 0,
      user: this.$store.getters.user,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol
    }
  },
  computed: {
    showSplitInvoiceModal () {
      // get the modal active state
      return this.$store.getters.showSplitInvoiceModal
    },
    remainderAmount () {
      // how much is left on the original job
      return (this.currentJob.amount - this.newAmount)
    },
    currentJob () {
      // the currently worked on job object
      return this.$store.getters.getSplitInvoiceModalJob
    },
    newJobTitle () {
      // the dynamic title using %
      return `${this.percentValue}% of ${this.currentJob.title}`
    },
    // evalutates if the amount is above zero, if not the create invoice button will disabled
    enableSave () {
      return this.percentValue !== 0 && this.percentValue !== 100 && this.percentValue !== ''
    },
    newLineItems: function () {
      let newItems = {}
      if (this.currentJob.id) {
        // iterate through the lineitems and create the new % based object
        // safely clone the line items without reactivity https://github.com/vuejs/Discussion/issues/292
        newItems = JSON.parse(JSON.stringify(this.currentJob.lineItems))
        // for each key do the math and append the description
        Object.keys(newItems).forEach((key) => {
          newItems[key].amount = parseFloat(((this.currentJob.lineItems[key].amount) * this.percentValue) / 100).toFixed(2)
          newItems[key].description = `${this.percentValue}% of ${this.currentJob.lineItems[key].description}`
          newItems[key].taxPortion = parseFloat(this.calcTaxPortion(((this.currentJob.lineItems[key].amount) * this.percentValue) / 100, this.currentJob.lineItems[key].taxRate, this.currentJob.taxIncluded)).toFixed(2)
          newItems[key].lineTotal = parseFloat(this.calcLineTotal(((this.currentJob.lineItems[key].amount) * this.percentValue) / 100, this.currentJob.lineItems[key].taxRate, this.currentJob.taxIncluded)).toFixed(2)
        })
      }
      return newItems
    },
    remainingLineItems: function () {
      let remainingItems = {}
      if (this.currentJob.id) {
        // iterate through the lineitems and create the new % based object
        // safely clone the line items without reactivity https://github.com/vuejs/Discussion/issues/292
        remainingItems = JSON.parse(JSON.stringify(this.currentJob.lineItems))
        // for each key do the math and append the description
        Object.keys(remainingItems).forEach((key) => {
          remainingItems[key].amount = parseFloat(((remainingItems[key].amount) * (100 - this.percentValue)) / 100).toFixed(2)
          remainingItems[key].description = `${100 - this.percentValue}% of ${remainingItems[key].description}`
          remainingItems[key].taxPortion = parseFloat(this.calcTaxPortion(remainingItems[key].amount, remainingItems[key].taxRate, this.currentJob.taxIncluded)).toFixed(2)
          remainingItems[key].lineTotal = parseFloat(this.calcLineTotal(remainingItems[key].amount, remainingItems[key].taxRate, this.currentJob.taxIncluded)).toFixed(2)
        })
      }
      return remainingItems
    }
  },
  watch: {
    percentValue: function () {
      this.newAmount = (this.currentJob.amount * this.percentValue) / 100
    },
    currentJob: function () {
      // if currentjob obj changes reset percent amount and set the newAmount value
      this.percentValue = 50
      if ((typeof this.currentJob === 'object') && (this.currentJob !== null)) {
        this.newAmount = (this.currentJob.amount * this.percentValue) / 100
      } else {
        this.newAmount = 0
      }
    }
  },
  methods: {
    createJobtitle (lineItems) {
      let concTitle = []
      const entries = Object.entries(lineItems)
      for (const [, itemDetails] of entries) {
        concTitle.push(itemDetails.description)
      }
      return concTitle.join(', ')
    },
    calcJobTaxPortion (lineItems) {
      let totalTaxPortion = 0
      const entries = Object.entries(lineItems)
      for (const [, itemDetails] of entries) {
        totalTaxPortion = parseFloat(totalTaxPortion) + parseFloat(itemDetails.taxPortion)
      }
      return totalTaxPortion
    },
    calcJobNetAmount (lineItems) {
      let totalNetAmount = 0
      const entries = Object.entries(lineItems)
      for (const [, itemDetails] of entries) {
        totalNetAmount = parseFloat(totalNetAmount) + parseFloat(itemDetails.amount)
      }
      return totalNetAmount
    },
    onSaveChanges () {
      if (this.newJobTitle.trim() === '') {
        return
      }
      // lets create the new job first
      // get new key
      const ref = firebase.database().ref(`lists/${this.user.group}/list${this.currentJob.listId}`).push().key
      // get top order to place this at the top
      const newListLowestOrder = this.$store.getters[`OrderedJobs${this.currentJob.listId}`][0].order - 1
      // set the latest job jey for immediately opening the job
      // turning this off for now, I'm not sure it looks right when doing this
      // this.$store.commit('setLatestJobKey', ref)

      // create the new job Object from the original with some overwrites
      const newJob = {
        ...this.currentJob,
        id: ref,
        title: this.createJobtitle(this.newLineItems),
        lineItems: this.newLineItems,
        amount: this.newAmount,
        totalTaxPortion: this.calcJobTaxPortion(this.newLineItems),
        totalNetAmount: this.calcJobNetAmount(this.newLineItems),
        order: newListLowestOrder
      }
      // write it to FB
      firebase.database().ref(`lists/${this.user.group}/list${this.currentJob.listId}/${ref}`).set(newJob)
        .then((data) => {
          this.$store.commit('setLoading', false)
        })
        .catch((error) => {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        })

      // now update the original job to reflect the deduction in amount
      // create the Update Obj
      const updatedOriginalJob = {
        ...this.currentJob,
        amount: this.remainderAmount,
        title: this.createJobtitle(this.remainingLineItems),
        lineItems: this.remainingLineItems,
        totalTaxPortion: this.calcJobTaxPortion(this.remainingLineItems),
        totalNetAmount: this.calcJobNetAmount(this.remainingLineItems)
      }
      // send it to the store - which in turn hits FB
      this.$store.dispatch('updateJob', { listId: this.currentJob.listId, payload: updatedOriginalJob })
      // close the modal
      this.closeModal()
      // clear and close the JobDetailModal
      this.$store.commit('toggleShowJobDetailModal')
      // close the modal by clearings the working Job from the store
      this.$store.commit('setJobDetailModalJob', {})
      // open the new invoice
      this.$router.push(`/invoices/show/${ref}`)
    },
    closeModal () {
      // reset to screen 1
      this.screen = 1
      // close the modal
      this.$store.commit('toggleShowSplitInvoiceModal')
      // close the modal by clearings the working Job from the store
      this.$store.commit('setSplitInvoiceModalJob', {})
    },
    calcTaxPortion (amount, taxRate, TaxIncluded) {
      let result = 0
      if (TaxIncluded) {
        result = (amount * (taxRate / 100)) / (1 + (taxRate / 100))
      } else {
        result = (amount * (taxRate / 100))
      }
      return parseFloat(result).toFixed(2)
    },
    calcLineTotal (amount, taxRate, TaxIncluded = false) {
      let result = 0
      if (TaxIncluded) {
        result = amount
      } else {
        result = amount * (1 + (taxRate / 100))
      }
      return parseFloat(result).toFixed(2)
    }
  }
}
</script>
<style lang="scss" >
  .splitpercent input {
    font-size:2rem !important;
    max-height:none;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
